import React from "react";
import { FiUser, FiPhone, FiMail } from "react-icons/fi";

export default function TeamMembers() {
  const team = [
    { name: "Rahul Kumar", role: "Frontend Developer", phone: "9876543210", email: "rahul@company.com" },
    { name: "Priya Sharma", role: "UI/UX Designer", phone: "9898989898", email: "priya@company.com" },
    { name: "Karan Patel", role: "Backend Developer", phone: "9123456789", email: "karan@company.com" },
  ];

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold mb-4">Team Members</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {team.map((emp, index) => (
          <div key={index} className="bg-white shadow rounded-2xl p-5 border">
            <h3 className="text-lg font-bold text-blue-600">{emp.name}</h3>
            <p className="text-gray-600 mb-3">{emp.role}</p>

            <div className="flex items-center gap-2 text-sm">
              <FiPhone /> {emp.phone}
            </div>
            <div className="flex items-center gap-2 text-sm mt-1">
              <FiMail /> {emp.email}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
